import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {IFaturamentoResourcesHolder} from '@/interfaces/resource/IFaturamentoResourcesHolder'
import {FaturamentoFilterCollection} from '@/model/filter/FaturamentoFilterCollection'

export class FaturamentoFilterSchema extends Schema
  implements IFaturamentoResourcesHolder {
  readonly name = 'FaturamentoFilter'

  readonly fieldSet: FieldSet<FaturamentoFilterCollection> = {
    mesAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        items: schema.model.monthOptions().allWithPlaceholder(),
        label: this.translateFrom(schema.fieldName),
      },
    }),
    anoAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        items: schema.model.yearList?.allWithPlaceholder(),
        label: this.translateFrom(schema.fieldName),
      },
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'cnpj',
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
